export default __webpack_public_path__ + "static/media/2220.29034734.png";